'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dList$002dCredentials$002dPage$0024 from "./presto.-List-Credentials-Page$.js";
import * as $j_presto$002e$002dPresto$002dRouter$0024$0024anon$002461 from "./presto.-Presto-Router$$anon$61.js";
import * as $j_presto$002etypes$0024$002dCredential$002dHash$0024 from "./presto.types$-Credential-Hash$.js";
var $p;
/** @constructor */
function $c_Lpresto_PrestoRouter$$anon$60() {
  this.blR = null;
  this.blJ = null;
  this.blK = false;
  this.blS = null;
  this.blT = false;
  this.blW = null;
  this.blP = null;
  this.blQ = false;
  this.blL = null;
  this.blM = false;
  this.blN = null;
  this.blO = false;
  this.blU = false;
  this.blV = false;
  this.blR = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.blW = "ListCredentialsPage";
}
export { $c_Lpresto_PrestoRouter$$anon$60 as $c_Lpresto_PrestoRouter$$anon$60 };
$p = $c_Lpresto_PrestoRouter$$anon$60.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_PrestoRouter$$anon$60;
/** @constructor */
function $h_Lpresto_PrestoRouter$$anon$60() {
}
export { $h_Lpresto_PrestoRouter$$anon$60 as $h_Lpresto_PrestoRouter$$anon$60 };
$h_Lpresto_PrestoRouter$$anon$60.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.K = (function() {
  return this.blR;
});
$p.M = (function() {
  if ((!this.blK)) {
    this.blJ = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.blK = true;
  }
  return this.blJ;
});
$p.O = (function() {
  if ((!this.blT)) {
    this.blS = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.blT = true;
  }
  return this.blS;
});
$p.D = (function() {
  return this.blW;
});
$p.t = (function() {
  if ((!this.blQ)) {
    this.blP = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("hash", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
    this.blQ = true;
  }
  return this.blP;
});
$p.N = (function() {
  if ((!this.blM)) {
    this.blL = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Decoder$OptionDecoder($j_presto$002etypes$0024$002dCredential$002dHash$0024.$m_Lpresto_types$CredentialHash$().ep())), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
    this.blM = true;
  }
  return this.blL;
});
$p.Q = (function() {
  if ((!this.blO)) {
    this.blN = new $j_presto$002e$002dPresto$002dRouter$0024$0024anon$002461.$c_Lpresto_PrestoRouter$$anon$61();
    this.blO = true;
  }
  return this.blN;
});
$p.v = (function() {
  if ((!this.blV)) {
    this.blU = false;
    this.blV = true;
  }
  return this.blU;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee447) => ((p) => \u03b4scrutinee447.cH7(p)))($j_presto$002e$002dList$002dCredentials$002dPage$0024.$m_Lpresto_ListCredentialsPage$())));
});
var $d_Lpresto_PrestoRouter$$anon$60 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_PrestoRouter$$anon$60, "presto.PrestoRouter$$anon$60", ({
  OB: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_PrestoRouter$$anon$60 as $d_Lpresto_PrestoRouter$$anon$60 };
//# sourceMappingURL=presto.-Presto-Router$$anon$60.js.map
